const init = async (element) => {
    // use this step to allow lazy loading of hljs
	const { init } = await import(/* webpackChunkName: "highlight.js" */ './highlight_control.js');
    init( element );
}

const Highlight = {
	init
}

export {
	Highlight
}